import { Options, Vue } from 'vue-class-component';

import { reactive, ref } from 'vue';
import type { ElForm } from 'element-plus';

type FormInstance = InstanceType<typeof ElForm>

import { login } from "@/api/index";
import { ElMessage } from 'element-plus';
@Options({
  components: {
    // HelloWorld
  }
})
export default class Login extends Vue {
  public ruleFormRef = ref<FormInstance>();
  public form = {
    username: '',
    password: '',
  }
  public rules = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  }

  public submitForm(formEl: any) {
    if (!formEl) return;
    formEl.validate((valid: any) => {
      if (valid) {
        this.login();
      } else {
        console.log('error submit!');
        return false;
      }
    });
  }

  public login() {
    login(this.form).then((res: any) => {
      if (res.code === 200) {
        sessionStorage.setItem('token', res.data.token);
        this.$router.replace('/backStageHome');
        ElMessage({
          message: '登录成功',
          type: 'success',
        });
      } else {
        ElMessage.error(res.msg);
      }
    });
  }


}